import React, { useState, useRef } from 'react';
import useEstMobile from '../hooks/useEstMobile';

const SEUIL = 70;      // distance de declenchement
const RESISTANCE = 2.2; // le doigt parcourt plus que l'indicateur ne descend

// Enveloppe une liste defilante : tirer vers le bas depuis le haut declenche
// onRafraichir. Inactif sur bureau, ou la molette rend le geste inutile.
export default function TirerPourRafraichir({ onRafraichir, children, style }) {
  const estMobile = useEstMobile();
  const [distance, setDistance] = useState(0);
  const [enCours, setEnCours] = useState(false);
  const depart = useRef(null);
  const conteneur = useRef(null);

  if (!estMobile) return <div style={style}>{children}</div>;

  const debut = (e) => {
    // Le geste ne doit pas concurrencer un defilement en cours
    if (!conteneur.current || conteneur.current.scrollTop > 0 || enCours) return;
    depart.current = e.touches[0].clientY;
  };

  const bouge = (e) => {
    if (depart.current === null) return;
    const delta = e.touches[0].clientY - depart.current;
    if (delta <= 0) { setDistance(0); return; }
    setDistance(Math.min(SEUIL * 1.5, delta / RESISTANCE));
  };

  const fin = async () => {
    if (depart.current === null) return;
    const atteint = distance >= SEUIL * 0.8;
    depart.current = null;
    if (!atteint) { setDistance(0); return; }

    setEnCours(true);
    setDistance(SEUIL * 0.6);
    try { await onRafraichir?.(); } finally {
      setEnCours(false);
      setDistance(0);
    }
  };

  return (
    <div
      ref={conteneur}
      style={{ ...style, overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}
      onTouchStart={debut}
      onTouchMove={bouge}
      onTouchEnd={fin}
      onTouchCancel={fin}
    >
      <div className="pull-indicateur" style={{ height: distance }}>
        {enCours ? 'Actualisation…' : (distance >= SEUIL * 0.8 ? 'Relâchez pour actualiser' : 'Tirez pour actualiser')}
      </div>
      {children}
    </div>
  );
}
